import React, { useEffect } from 'react'
import AboutUsWidget from '../components/AboutUsWidget'
import PropertiesWidget from '../components/PropertiesWidget'
import HeroSection from '../components/HeroSection'
import WhyChooseUs from '../components/WhyChooseUs'

function Home() {
  useEffect(() => {
    const hash = window.location.hash;
    if (hash) {
      const element = document.querySelector(hash);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }, []);
  return (
    <div>
      
      <section id="home"><HeroSection/></section>
      <section id="about"><WhyChooseUs/></section>
      <AboutUsWidget/>
      <section id="properties">
        <PropertiesWidget/>
        </section>
    </div>
  )
}

export default Home